import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../GlobalContext';

const DaftarSimpManasuka = () => {
  const { periode, api } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    tanggal: new Date().toISOString().split('T')[0],
    simpanan: 'manasuka',
  });
  const [simpData, setSimpData] = useState([]);
  const [message, setMessage] = useState('');

  const getSelectedSimpananLabel = () => {
    if (formData.simpanan === 'hariraya') {
      return 'Simpanan Hari Raya';
    }

    if (formData.simpanan === 'wajibbelanja') {
      return 'Simpanan Wajib Belanja';
    }

    return 'Simpanan Manasuka';
  };

  const parseAmount = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return value;

    const normalized = String(value).trim().replace(/\s/g, '');
    if (!normalized) return 0;

    const cleaned = normalized.includes(',')
      ? normalized.replace(/\./g, '').replace(',', '.')
      : normalized.replace(/,/g, '');

    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getNoTransaksi = (row) => row.notransaksi || row.notransassi || '-';

  const getTransactionLabel = (row) => {
    if (row.transaksi) return row.transaksi;

    switch (String(row.kdtrans || '')) {
      case '1':
        return 'Setoran';
      case '2':
        return 'Penarikan';
      case '3':
        return 'Jasa';
      default:
        return '-';
    }
  };

  const fetchSimpData = async () => {
    setLoading(true);
    setMessage('');

    try {
      let endpointLaporan = `/api/laporan/manasuka/${formData.tanggal}/${formData.tanggal}`;
      if (formData.simpanan === 'hariraya') {
        endpointLaporan = `/api/laporan/hariraya/${formData.tanggal}/${formData.tanggal}`;
      } else if (formData.simpanan === 'wajibbelanja') {
        endpointLaporan = `/api/laporan/vbelanja/${formData.tanggal}/${formData.tanggal}`;
      }

      const response = await api.get(endpointLaporan);

      const dataArray = Array.isArray(response.data)
        ? response.data
        : (Array.isArray(response.data?.data) ? response.data.data : []);

      setSimpData(dataArray);
    } catch (error) {
      console.error(`Error fetching ${getSelectedSimpananLabel().toLowerCase()} data:`, error);
      setMessage(`Gagal mengambil data ${getSelectedSimpananLabel().toLowerCase()}. Silakan coba lagi.`);
      setSimpData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchSimpData();
  };

  useEffect(() => {
    fetchSimpData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.tanggal, formData.simpanan]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    }).format(parseAmount(value));
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
    }).format(parseAmount(value));
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';

    const value = String(dateString);
    if (value.includes('T')) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;

      return date.toLocaleDateString('id-ID', {
        timeZone: 'Asia/Jakarta',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    }

    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const [, year, month, day] = isoMatch;
      return `${day}/${month}/${year}`;
    }

    const localMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (localMatch) {
      return value.replace(/-/g, '/');
    }

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const totalDebet = simpData.reduce((sum, row) => sum + parseAmount(row.debet), 0);
  const totalKredit = simpData.reduce((sum, row) => sum + parseAmount(row.kredit), 0);
  const selectedPeriode = formData.tanggal.replace(/-/g, '').substring(0, 6);
  const isCurrentPeriod = selectedPeriode === String(periode || '');

  return (
    <div className="container-fluid mt-4">
      <div className="card" style={{ borderTop: '3px solid #17a2b8' }}>
        <div className="card-header" style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
          <h5 className="card-title mb-0">Daftar Simpanan</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSearch}>
            <div className="row mb-3">
              <div className="col-md-3">
                <label htmlFor="tanggal" className="form-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Tanggal</label>
                <input
                  type="date"
                  className="form-control"
                  id="tanggal"
                  name="tanggal"
                  value={formData.tanggal}
                  onChange={handleInputChange}
                  style={{ fontSize: '14px' }}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="simpanan" className="form-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Simpanan</label>
                <select
                  className="form-control"
                  id="simpanan"
                  name="simpanan"
                  value={formData.simpanan}
                  onChange={handleInputChange}
                  style={{ fontSize: '14px' }}
                >
                  <option value="manasuka">Simpanan Manasuka</option>
                  <option value="hariraya">Simpanan Hari Raya</option>
                  <option value="wajibbelanja">Simpanan Wajib Belanja</option>
                </select>
              </div>
              <div className="col-md-2" style={{ paddingTop: '31px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ fontSize: '14px' }}
                >
                  {loading ? 'Mencari...' : 'Cari'}
                </button>
              </div>
            </div>
          </form>

          {message && (
            <div className="alert alert-info alert-dismissible fade show" role="alert" style={{ marginTop: '15px', fontSize: '14px' }}>
              {message}
            </div>
          )}

          <div className="table-responsive mt-4">
            <table className="table table-bordered" style={{ fontSize: '14px', marginBottom: '0' }}>
              <thead>
                <tr style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
                  <th style={{ width: '5%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>No.</th>
                  <th style={{ width: '12%', padding: '10px', borderColor: '#17a2b8' }}>Tanggal</th>
                  <th style={{ width: '13%', padding: '10px', borderColor: '#17a2b8' }}>No. Transaksi</th>
                  <th style={{ width: '10%', padding: '10px', borderColor: '#17a2b8' }}>No. Anggota</th>
                  <th style={{ width: '18%', padding: '10px', borderColor: '#17a2b8' }}>Nama</th>
                  <th style={{ width: '12%', padding: '10px', borderColor: '#17a2b8' }}>Transaksi</th>
                  <th style={{ width: '10%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Debet</th>
                  <th style={{ width: '10%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Kredit</th>
                  <th style={{ width: '8%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(simpData) && simpData.length > 0 ? (
                  simpData.map((row, index) => (
                    <tr key={index} style={{ borderColor: '#ddd' }}>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>{index + 1}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{formatDate(row.tgltransak || row.tanggal)}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{getNoTransaksi(row)}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.noanggota || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.nama || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{getTransactionLabel(row)}</td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.debet || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.kredit || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>
                        {isCurrentPeriod && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            title="Hapus"
                            onClick={async () => {
                              const noTransaksi = row.notransaksi || row.notransassi;
                              if (!noTransaksi) return alert('Tidak ada nomor transaksi untuk dihapus.');
                              if (window.confirm('Yakin ingin menghapus transaksi ini?')) {
                                try {
                                  let endpointHapus = `/api/transaksi/manasuka/${noTransaksi}`;

                                  if (formData.simpanan === 'hariraya') {
                                    endpointHapus = `/api/transaksi/hariraya/${noTransaksi}`;
                                  } else if (formData.simpanan === 'wajibbelanja') {
                                    endpointHapus = `/api/transaksi/voucher/${noTransaksi}`;
                                  }
                                  await api.delete(endpointHapus);
                                  alert('Data berhasil dihapus.');
                                  fetchSimpData();
                                } catch (err) {
                                  console.error('Hapus gagal:', err);
                                  alert('Tidak dapat menghapus: endpoint belum tersedia atau terjadi kesalahan.');
                                }
                              }
                            }}
                          >
                            <i className="fa fa-trash" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center" style={{ padding: '20px', color: '#999', borderColor: '#ddd' }}>
                      {loading ? 'Memproses data...' : 'Tidak ada data. Silakan gunakan filter untuk mencari data.'}
                    </td>
                  </tr>
                )}
                {Array.isArray(simpData) && simpData.length > 0 && (
                  <tr style={{ borderTop: '2px solid #17a2b8' }}>
                    <td colSpan="6" style={{ padding: '10px', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8', textAlign: 'center' }}>
                      Total:
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalDebet)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalKredit)}
                    </td>
                    <td style={{ padding: '10px', borderColor: '#ddd' }} />
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DaftarSimpManasuka;
